import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconFeedback = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
      <g>
        <path fill={fill} opacity={0.3} d="M4 4h16v12H7l-3 4V4Z" />
        <path fill={fill} d="M8 8h8v2H8V8Zm0 4h5v2H8v-2Z" />
      </g>
    </svg>
  )
}

export default IconFeedback